import Application from "./Application";
import common from "./common";
import DisplayObjectManager from "./utils/DisplayObjectManager";
import AudioManager from "./utils/AudioManager";
import TextManager from "./utils/TextManager";
import SaveData from "./utils/SaveData";
import PreloaderScene from "./scenes/PreloaderScene";

export default class Main {
    /**
     * @param {number} [width=1024]
     * @param {number} [height=768]
     */
    constructor(width = 1024, height = 768)
    {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;

        this._baseUrl = './';
    }

    init()
    {
        common.country = COUNTRY_CODE;
        common.STAGE_WIDTH = 1792;
        common.STAGE_HEIGHT = 768;
        common.STAGE_HALF_WIDTH = common.STAGE_WIDTH / 2;
        common.STAGE_HALF_HEIGHT = common.STAGE_HEIGHT / 2;

        common.baseUrl = this._baseUrl;

        common.audio = new AudioManager();

        common.saveData = new SaveData();

        //PIXI.utils.skipHello();
        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;

        typeof TweenMax !== "undefined" && (TweenMax.defaultOverwrite = "none");

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: this._baseUrl + "assets/images/1x/ui_rotate_device.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function(canvas)
        {
            const options = {};
            options.view = canvas;
            options.transparent = true;
            options.antialias = true;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            if (P3.utils.isCocoonJS()) {
                stage.scale.x = window.innerHeight / this._height;
                stage.scale.y = window.innerHeight / this._height;
            }

            //const renderer = new PIXI.CanvasRenderer(window.innerWidth, window.innerHeight, options);
            const renderer = new PIXI.autoDetectRenderer(window.innerWidth, window.innerHeight, options);
            renderer.backgroundColor = 0x000000;
            common.renderer = renderer;
            common.canvasMode = common.renderer.type === 2;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            common.display = new DisplayObjectManager();
            common.display.init();

            common.text = new TextManager();

            const ticker = new P3.Ticker();
            ticker.init(function()
            {
                P3.scene.update();
                P3.input.update();
                //P3.utils.TWEEN.update();     // comment this line out if you are using TweenMax
            }, function() {
                common.timeElapsed += P3.Ticker.dt * common.timeStretch;
                renderer.render(stage);
                if(this._app) this._app.update();
            }, this);
            common.ticker = ticker;

            this.loadPreAssets();

        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function() {view.init()}, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope)
    {
        scope = scope || window;
        var config = [
            {name:"settings_config", url:"assets/data/settings.json"},
            {name:"characters_config", url:"assets/data/characters.json"},
            {name:"weapons_config", url:"assets/data/weapons.json"},
            {name:"translations_config", url:"assets/data/translations.json"}
        ];

        if(config.length > 0)
        {
            P3.assets.addFiles(config, this._baseUrl);
            P3.assets.signals.complete.once(function() {
                common.config = {};
                callback && callback.call(scope);
            }, this);
            P3.assets.load();
        }
        else
        {
            callback.call(scope);
        }
    }

    loadPreAssets()
    {
        common.config.settings = P3.assets.json("settings_config");
        common.config.characters = P3.assets.json("characters_config").characters;
        common.config.weapons = P3.assets.json("weapons_config");
        common.config.translations = P3.assets.json("translations_config");

        console.log(common.config);

        const files = [
            {name:"preloader_1x", url:"images/1x/preloader_1x.json"},
            {name:"font_pangolin_26_stats",   url:"fonts/pangolin_26_stats.fnt"},
            {name:"font_lalezar_48_results",   url:"fonts/lalezar_48_results.fnt"},
            {name:"font_lalezar_56_titles",   url:"fonts/lalezar_56_titles.fnt"},
            {name:"font_lalezar_100_numbers",   url:"fonts/lalezar_100_numbers.fnt"}
        ];

        if (files.length) {
            P3.assets.addFiles(files, this._baseUrl + "assets/");
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else this.loadAssets();
    }

    loadAssets()
    {
        const files = [
            {name:"ui_1",                       url:"images/1x/ui_1_1x.json"},
            {name:"bg",                         url:"images/1x/bg_1x.jpg"},
            {name:"bg_gameplay",                url:"images/1x/bg_gameplay_1x.jpg"},
            {name:"logo_game",                  url:"images/localisation/logo_game_" + common.country + ".png"},
            {name:"logo_ip",                    url:"images/localisation/logo_ip_" + common.country + ".png"},
            {name:"spine_batgirl",              url:"spine/0.25x/batgirl.json"},
            {name:"spine_batgirl_big",          url:"spine/0.7x/batgirl.json"},
            {name:"spine_bumblebee",            url:"spine/0.25x/bumblebee.json"},
            {name:"spine_bumblebee_big",        url:"spine/0.7x/bumblebee.json"},
            {name:"spine_greenlantern",         url:"spine/0.25x/greenlantern.json"},
            {name:"spine_greenlantern_big",     url:"spine/0.7x/greenlantern.json"},
            {name:"spine_supergirl",            url:"spine/0.25x/supergirl.json"},
            {name:"spine_supergirl_big",        url:"spine/0.7x/supergirl.json"},
            {name:"spine_wonderwoman",          url:"spine/0.25x/wonderwoman.json"},
            {name:"spine_wonderwoman_big",      url:"spine/0.7x/wonderwoman.json"},
            {name:"spine_zatana",               url:"spine/0.25x/zatana.json"},
            {name:"spine_zatana_big",           url:"spine/0.7x/zatana.json"},
            {name:"spine_catwoman",             url:"spine/0.25x/catwoman.json"},
            {name:"spine_catwoman_big",         url:"spine/0.7x/catwoman.json"},
            {name:"spine_harleyquinn",          url:"spine/0.25x/harleyquinn.json"},
            {name:"spine_harleyquinn_big",      url:"spine/0.7x/harleyquinn.json"},
            {name:"spine_poisonivy",            url:"spine/0.25x/poisonivy.json"},
            {name:"spine_poisonivy_big",        url:"spine/0.7x/poisonivy.json"},
            {name:"particle_splat_yoghurt",     url:"particles/particle_splat_yoghurt_00.json"},
            {name:"particle_flour_bomb",        url:"particles/particle_flour_bomb.json"},
            {name:"particle_flour_trail",       url:"particles/particle_flour_trail_00.json"},
            {name:"particle_steam_emitter",     url:"particles/particle_steam_emitter_00.json"},
            {name:"particle_powerup_attract",   url:"particles/particle_powerup_attract_00.json"},
            {name:"particle_result_star_appear",   url:"particles/particle_result_star_appear_00.json"}
        ];

        const audio = [
            {name:'music_choose_character_loop', url:'music_choose_character_loop_00'},
            {name:'music_fight_loop', url:'music_fight_loop_01'},
            {name:'music_pause_loop', url:'music_pause_loop_00'},
            {name:'music_results_loop', url:'music_results_loop_00'},
            {name:'music_splash_loop', url:'music_splash_loop_00'},
            {name:'music_splash_press_play_sting', url:'music_splash_press_play_sting_00'},
            {name:'music_you_lose_sting', url:'music_you_lose_sting_00'},
            {name:'sfx_char_land_00', url:'sfx_char_land_00'},
            {name:'sfx_char_land_01', url:'sfx_char_land_01'},
            {name:'sfx_char_slip_00', url:'sfx_char_slip_00'},
            {name:'sfx_char_slip_01', url:'sfx_char_slip_01'},
            {name:'sfx_char_slip_02', url:'sfx_char_slip_02'},
            {name:'sfx_char_slip_03', url:'sfx_char_slip_03'},
            {name:'sfx_crowd_chatter_mix_loop', url:'sfx_crowd_chatter_mix_loop_02'},
            {name:'sfx_crowd_laughter_00', url:'sfx_crowd_laughter_00'},
            {name:'sfx_crowd_laughter_01', url:'sfx_crowd_laughter_01'},
            {name:'sfx_crowd_laughter_02', url:'sfx_crowd_laughter_02'},
            {name:'sfx_crowd_laughter_03', url:'sfx_crowd_laughter_03'},
            {name:'sfx_crowd_laughter_04', url:'sfx_crowd_laughter_04'},
            {name:'sfx_crowd_laughter_05', url:'sfx_crowd_laughter_05'},
            {name:'sfx_crowd_laughter_06', url:'sfx_crowd_laughter_06'},
            {name:'sfx_crowd_laughter_07', url:'sfx_crowd_laughter_07'},
            {name:'sfx_crowd_laughter_08', url:'sfx_crowd_laughter_08'},
            {name:'sfx_fight_end_school_bell', url:'sfx_fight_end_school_bell_00'},
            {name:'sfx_food_banana_land_01', url:'sfx_food_banana_land_01'},
            {name:'sfx_food_banana_land_02', url:'sfx_food_banana_land_02'},
            {name:'sfx_food_banana_land_03', url:'sfx_food_banana_land_03'},
            {name:'sfx_food_carrot_01', url:'sfx_food_carrot_01'},
            {name:'sfx_food_carrot_02', url:'sfx_food_carrot_02'},
            {name:'sfx_food_carrot_03', url:'sfx_food_carrot_03'},
            {name:'sfx_food_carrot_04', url:'sfx_food_carrot_04'},
            {name:'sfx_food_carrot_05', url:'sfx_food_carrot_05'},
            {name:'sfx_food_flour_explode_00', url:'sfx_food_flour_explode_00'},
            {name:'sfx_food_splat_dry_00', url:'sfx_food_splat_dry_00'},
            {name:'sfx_food_splat_dry_01', url:'sfx_food_splat_dry_01'},
            {name:'sfx_food_splat_dry_02', url:'sfx_food_splat_dry_02'},
            {name:'sfx_food_splat_dry_03', url:'sfx_food_splat_dry_03'},
            {name:'sfx_food_splat_dry_04', url:'sfx_food_splat_dry_04'},
            {name:'sfx_food_splat_dry_05', url:'sfx_food_splat_dry_05'},
            {name:'sfx_food_splat_sloppy_00', url:'sfx_food_splat_sloppy_00'},
            {name:'sfx_food_splat_sloppy_01', url:'sfx_food_splat_sloppy_01'},
            {name:'sfx_food_splat_sloppy_02', url:'sfx_food_splat_sloppy_02'},
            {name:'sfx_food_splat_sloppy_03', url:'sfx_food_splat_sloppy_03'},
            {name:'sfx_food_splat_sloppy_04', url:'sfx_food_splat_sloppy_04'},
            {name:'sfx_food_splat_sloppy_05', url:'sfx_food_splat_sloppy_05'},
            {name:'sfx_food_splat_soft_00', url:'sfx_food_splat_soft_00'},
            {name:'sfx_food_splat_soft_01', url:'sfx_food_splat_soft_01'},
            {name:'sfx_food_splat_soft_02', url:'sfx_food_splat_soft_02'},
            {name:'sfx_food_splat_soft_03', url:'sfx_food_splat_soft_03'},
            {name:'sfx_food_splat_soft_04', url:'sfx_food_splat_soft_04'},
            {name:'sfx_food_splat_soft_05', url:'sfx_food_splat_soft_05'},
            {name:'sfx_food_splat_wet_00', url:'sfx_food_splat_wet_00'},
            {name:'sfx_food_splat_wet_01', url:'sfx_food_splat_wet_01'},
            {name:'sfx_food_splat_wet_02', url:'sfx_food_splat_wet_02'},
            {name:'sfx_food_splat_wet_03', url:'sfx_food_splat_wet_03'},
            {name:'sfx_food_splat_wet_04', url:'sfx_food_splat_wet_04'},
            {name:'sfx_food_splat_wet_05', url:'sfx_food_splat_wet_05'},
            {name:'sfx_food_splat_wet_06', url:'sfx_food_splat_wet_06'},
            {name:'sfx_footstep_mid_00', url:'sfx_footstep_mid_00'},
            {name:'sfx_footstep_mid_01', url:'sfx_footstep_mid_01'},
            {name:'sfx_footstep_mid_02', url:'sfx_footstep_mid_02'},
            {name:'sfx_footstep_mid_03', url:'sfx_footstep_mid_03'},
            {name:'sfx_footstep_mid_04', url:'sfx_footstep_mid_04'},
            {name:'sfx_knockout_00', url:'sfx_knockout_00'},
            {name:'sfx_knockout_01', url:'sfx_knockout_01'},
            {name:'sfx_powerup_arrive_00', url:'sfx_powerup_arrive_00'},
            {name:'sfx_powerup_arrive_01', url:'sfx_powerup_arrive_01'},
            {name:'sfx_take_powerup_00', url:'sfx_take_powerup_00'},
            {name:'sfx_throw_heavy_00', url:'sfx_throw_heavy_00'},
            {name:'sfx_throw_light_00', url:'sfx_throw_light_00'},
            {name:'sfx_throw_light_01', url:'sfx_throw_light_01'},
            {name:'sfx_throw_light_02', url:'sfx_throw_light_02'},
            {name:'sfx_throw_mid_00', url:'sfx_throw_mid_00'},
            {name:'sfx_throw_v_light_00', url:'sfx_throw_v_light_00'},
            {name:'sfx_throw_v_light_01', url:'sfx_throw_v_light_01'},
            {name:'silence', url:'silence'},
        ];
        common.audio.addSounds(audio, [".mp4", ".ogg"], common.baseUrl + "assets/audio/");

        common.audio.playSound('silence');

        if (files.length) {
            this._preloader = new PreloaderScene();
            P3.scene.show(this._preloader);

            P3.assets.addFiles(files, this._baseUrl + "assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();

        } else this.start();
    }

    start()
    {
        var atlas = new PIXI.spine.core.TextureAtlas();
        var textures = ['frame_005', 'frame_011', 'frame_016', 'frame_024', 'frame_030', 'frame_041', 'frame_053', 'frame_065'];
        var allTextures = {};
        for(var i in textures)
        {
            allTextures[textures[i]] = P3.assets.texture(textures[i]);
        }
        atlas.addTextureHash(allTextures, true);
        P3.assets.addFiles([{name:'vfx_spine', url:'spine/vfx.json', metadata: {spineAtlas: atlas} }], this._baseUrl + "assets/");
        P3.assets.load();


        if(this._preloader) this._preloader.exit();
        setTimeout(function()
        {
            this._app = new Application();
            this._app.init();
        }.bind(this), 1000);
    }

    onLoadingProgress(event)
    {
        this._preloader && (this._preloader.loaded = event.progress / 100);
        //console.log("loading:", event.progress);
    }

    onLoadingCompleted()
    {
        this._preloader && (this._preloader.loaded = 1);
        //this._preloader.addPlayButton();
        //this._preloader.signals.next.add(function() {
            this.start();
        //}, this);
    }

    onCanvasResize(correct)
    {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }
}


